import { FluentVariable } from '@fluent/bundle';

/** True when deployed for the 5T service provider (`SERVICE_PROVIDER_ID=5T`). */
export const is5tServiceProvider = (): boolean =>
  process.env.SERVICE_PROVIDER_ID?.toUpperCase() === '5T';

/** 5T deployments label the feature VMS; all other providers use PMV. */
export const getPmvDisplayTerm = (): 'VMS' | 'PMV' =>
  is5tServiceProvider() ? 'VMS' : 'PMV';

export const pmvL10nArgs = (
  extra?: Record<string, FluentVariable>,
): Record<string, FluentVariable> => ({
  pmvTerm: getPmvDisplayTerm(),
  ...extra,
});
